export default "__VITE_ASSET__BNY$7lIp__"